import { css } from "lit";

export const styles = css`
  .thank-you-slide {
    --thank-you-slide-icon-container-width: 80px;
    background-color: var(--color-white);
    width: 100%;
    height: 100%;
    display: block;
  }

  .content {
    height: var(--slide-default-height);
    padding: var(--size-15);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: var(--size-1);
    text-align: center;
  }

  .title {
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-8xl);
    line-height: var(--line-height-normal);
  }

  .post-title {
    font-weight: var(--font-weight-normal);
    font-size: var(--font-size-5xl);
    line-height: var(--line-height-normal);
    line-height: var(--line-height-snug);
  }
`;
